<ng-container *ngIf="showDualShotClockHeader(); else singleTimer">
  <div class="shot-clock-dual-timer">
    <div class="content-text content-text-highlight">{{ catalogRemainingMessage?.status }} {{ catalogRemainingMessage?.timeRemaining }}</div>
    <div class="content-text content-text-highlight" [ngClass]="{ 'urgent': inLastMinutesOfNextEvent() }">{{ timeRemainingMessage.status }}{{ timeRemainingMessage.timeRemaining == "" ? ":" : "" }} {{ timeRemainingMessage.timeRemaining }}</div>
  </div>
</ng-container>
<ng-template #singleTimer>
  <span class="content-text content-text-highlight" [ngClass]="{ 'urgent': inLastMinutesOfNextEvent() }">{{ timeRemainingMessage.status }}{{ timeRemainingMessage.timeRemaining == "" ? ":" : "" }} {{ timeRemainingMessage.timeRemaining }}</span>
</ng-template>
